/**
 * Created by ccg
 * Date 2019/1/2
 */
import * as Types from '@/store/modules/engineering/mutations-types';
import { COM_SEND_TYPE, COMPONENT_TYPE } from '@/common/enums';
import { buildDB } from '@/utils/utilFun';
import Constants from '@/common/Constants';
import cloneDeep from 'lodash/fp/cloneDeep';
import {
  getCurCmpData,
  getCurCmpDataSourceData,
  getCurCmpSignalData,
  transformToDashboard,
  transformToSignalCmp,
  transformToSingleBind,
  transformToSubmit,
} from '@/utils/engineeringFun';

export default {
  /**
   * 设置标定量组件步幅
   * @param state
   * @param singIndex
   * @param stepList
   */
  setSingleBindStep(state, { singIndex, stepList }) {
    state.panelDataCcg[singIndex].steps = stepList;
    stepList.forEach((item, key) => {
      state.panelDataCcg[singIndex].dataSources[key].step = item;
    });
  },
  /**
   * 设置锚点跳转的id
   * @param state
   * @param id
   */
  setAnchorPointId(state, id) {
    state.anchorPointId = id;
  },
  /**
   * 设置左侧树配置数据
   */
  [Types.SET_TREE_CONFIG_DATA](state, obj) {
    state.treeConfigData = obj.map((deviceItem) => {
      const {
        recAllAsc = false,
        recAscByDbc = false,
        playDat = false,
        recAllBlf = false,
        recBlfByDbc = false,
        autoStart = false,
        deviceId = '',
        segmentLength = 0,
        targets = [],
        canConfigs,
        events = {},
        namePrefix = '',
        sigPrefix = '',
        isPlay = '',
      } = deviceItem;
      const targetsList = targets.map((targetItem) => {
        const {
          enabled = false, interval, key = '', event = '',
        } = targetItem;
        return {
          enabled, interval: interval !== null ? interval : 1, key, event,
        };
      });
      return {
        autoStart,
        deviceId,
        segmentLength,
        namePrefix,
        sigPrefix,
        targets: targetsList,
        canConfigs,
        events,
        recAllAsc,
        recAscByDbc,
        playDat,
        recAllBlf,
        recBlfByDbc,
      };
    });
  },
  [Types.DELETE_DATASOURCE](state, { cptIndex, dataSourceKey }) {
    const dataSourceIndex = state.panelDataCcg[cptIndex].dataSources.findIndex(item => item.key === dataSourceKey);
    state.panelDataCcg[cptIndex].dataSources.splice(dataSourceIndex, 1);
    this.dispatch('Engineering/saveAllCpt');
  },
  /**
   * 设置CAN状态
   * @param state
   * @param data
   */
  [Types.SET_CAN_STATUS](state, { data }) {
    const initValues = [];
    // console.log('标定测试标定测试标定测试');
    // console.log(data);
    // data.map((canData) => {
    //   canData.initValues.map((item) => {
    //     initValues.push(item);
    //   });
    // });
    data.map((deviceData) => {
      deviceData.canData.map((canData) => {
        canData.invariantDataList.map((item) => {
          initValues.push(item);
        });
      });
    });
    state.initValues = initValues;
    window.sessionStorage.setItem('initValues', JSON.stringify(initValues));
  },
  /**
   * 单数据显示组件，清空dataSource和chartData
   * @param state
   * @param componentIndex
   */
  deleteSingleOutputDataSources(state, { componentIndex, value }) {
    const { chartData } = state.panelDataCcg[componentIndex];
    state.panelDataCcg[componentIndex].dataSources[0].value = value;
  },
  /**
   * 设置当前面板状态
   * @param state
   * @param paload
   */
  [Types.SET_CURPANEL_STATUS](state, paload) {
    const { type } = paload;
    state.curPanelStatus = type;
  },
  /**
   * 设置当前工程状态
   * @param state
   * @param paload
   */
  [Types.SET_CURPROJECT_STATUS](state, paload) {
    const { type } = paload;
    state.curProjectStatus = type;
  },
  setEchartResizeKey(state) {
    state.echartResizeKey += 1;
  },
  // 设置当前页面请求的面板id
  [Types.SET_CUR_PANELID](state, panelId) {
    state.panelId = panelId;
  },
  // 设置当前页面请求的面板id
  [Types.SET_PROJETLID](state, projectId) {
    state.projectId = projectId;
  },
  // 修改grid位置或大小
  setGrid(state, payload) {
    const {
      type = '', x = 0, y = 0, i = 0,
    } = payload;
    if (type === 'pos') {
      state.panelDataCcg[i].x = x;
      state.panelDataCcg[i].y = y;
    } else if (type === 'size') {
      state.panelDataCcg[i].h = y;
      state.panelDataCcg[i].w = x;
    }
    state.panelChanged = true;
  },
  /**
   * 初始化获取组件数据，设置到vuex
   * @param state
   * @param payload
   */
  [Types.SET_PANELDATA_CG](state, payload) {
    state.panelDataCcg = payload.map((item) => {
      const {
        ctype, cid = '', name = '', comment = '', pos = { x: 0, y: 0 }, zindex = 999,
        size = { x: 10, y: 10 },
      } = item;
      let re = {
        ctype,
        cid,
        name,
        comment,
        zindex,
        i: 0,
        w: size.x,
        h: size.y,
        x: pos.x,
        y: pos.y,
      };
      if (ctype === COMPONENT_TYPE.Oscillogram) { // 示波图
        const {
          enables = [],
          dataSources = [],
        } = item;
        const chartData = dataSources.map(dataSourceitem => ({
          key: dataSourceitem.key,
          values: [],
        }));
        re = {
          ...re,
          enables,
          dataSources,
          chartData,
        };
      } else if (ctype === COMPONENT_TYPE.DASHBOARD) { // 仪表盘
        const {
          dataSources = [],
          chartData = [],
        } = item;
        re = {
          ...re,
          chartData,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.INPUT) { // 输入组件
        const { steps = [], dataSources = [] } = item;
        const da = dataSources.map((ditem, key) => ({
          key: ditem.key,
          text: ditem.text,
          type: ditem.type,
          step: steps[key] || 1,
        }));
        re = {
          ...re,
          steps,
          dataSources: da,
        };
      } else if (ctype === COMPONENT_TYPE.SEND) { // 发送组件
        const { sendType = COM_SEND_TYPE.NOW, cycleTime = 0, dataSources = [] } = item;
        re = {
          ...re,
          sendType,
          cycleTime,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.OUTPUT || ctype === COMPONENT_TYPE.NUMERICINDICATOR || ctype === COMPONENT_TYPE.CONDITION) { // 单数据显示
        const { dataSources } = item;
        const ds = dataSources.map((item2) => {
          const { key, text, type } = item2;
          return {
            key, text, type,
          };
        });
        re = {
          ...re,
          dataSources: ds,
          chartData: [],
          styleSetting: [],
        };
      } else if (ctype === COMPONENT_TYPE.SWITCHER) { // 枚举图
        const {
          dataSources, chartData = [], falseValue = 0, trueValue = 1,
        } = item;
        re = {
          ...re,
          dataSources,
          chartData,
          falseValue,
          trueValue,
        };
      } else if (ctype === COMPONENT_TYPE.MAP) { // 地图
        const { dataSources } = item;
        re = {
          ...re,
          dataSources,
          chartData: [],
        };
      } else if (ctype === COMPONENT_TYPE.UDS || ctype === COMPONENT_TYPE.CUSTOMFRAMES) {
        // 对UDS模块，dataSources对应于模板的绑定信息
        // 自定义帧模块
        const { dataSources } = item;
        re = {
          ...re,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.NUMERICCONTROL || ctype === COMPONENT_TYPE.TRIGGER || ctype === COMPONENT_TYPE.SLIDER) {
        const { dataSources } = item;
        re = {
          ...re,
          dataSources,
          styleSetting: [],
        };
      }
      return re;
    });
  },
  // 设置左边树的数据
  setLeftStructure(state, payload) {
    const { leftStructure } = payload;
    state.leftStructure = leftStructure;
    state.treeDatabase = buildDB(leftStructure);
  },
  // 左侧显示过滤（all, dbc, a2l）
  setDisplayType(state, payload) {
    state.leftDisplayType = payload.type;
  },
  // 通道设置，改变对应通道的设置
  setCANSetting(state, payload) {
    const { leftStructure } = state;
    // console.log(state);
    state.leftStructure = leftStructure.map((item) => {
      let tempItem = cloneDeep(item);
      // 如果树形结构的通道type为配置的id（通道配置id也是通过type来请求的）
      if (tempItem.type === payload.id) {
        tempItem = { ...tempItem, ...payload };
      }
      return tempItem;
    });
  },
  // 设置设备通道list
  setDeviceListOptions(state, payload) {
    state.deviceListOptions = payload.deviceListOptions;
  },
  setA2LBindEventData(state, payload) {
    const { headerArr, checkArr } = payload;
    state.a2lBindEventData.columns = ['名称', ...headerArr];
    state.a2lBindEventData.data = checkArr.map(item => ({
      measureName: item.measureName,
      ...item.check,
    }));
  },
  setDragNodeType(state, payload) {
    state.dragTreeNodeType = payload.type;
  },
  setDragTreeNodeKey(state, { key = '' }) {
    state.dragTreeNodeKey = key;
  },
  // 点击相应的面板
  clickDetailTab(state, payload) {
    const { panelList } = state;
    const { index, that, fresh = false } = payload;
    state.displayDetailTabIndex = index;
    const curPanelId = panelList[index].id;
    window.localStorage.setItem('panel', curPanelId);
    // 如果默认是开启的状态
    if (window.localStorage.getItem(`${curPanelId}-status`) === 'true') {
      panelList[index].hasStart = true;
      if (fresh) {
        this.dispatch('Engineering/initWebsocket', { panelId: curPanelId, that });
      }
    } else { // 如果本地换成没有panel开启的信息或是为false
      panelList[index].hasStart = false;
    }
    // const panelId = panelList[index].id;
    // 清空之前有选中的模块index
    for (const val of Object.keys(state.activedClickCmp)) {
      state.activedClickCmp[val] = 0;
    }
    // 重新组装现有面板的结构，得出对应的组件位置结构cmpPositionStyle
    // this.commit('Engineering/gridLayoutData', { panelId });
  },
  // 根据activedPanelData生成对应的vue-grid-layout的结构
  gridLayoutData(state, payload) {
    const {
      initPanelDataObj,
      componentStyle,
      PANELCOLWIDTH,
      cmpPositionStyle,
    } = state;
    let preX = state.curComponentX;
    let preY = state.curComponentY;
    const { panelId } = payload;
    for (const cmpName of Object.keys(initPanelDataObj[panelId])) {
      if (cmpName !== undefined && cmpName !== 'dataSource' && cmpName !== 'cid') {
        const length = initPanelDataObj[panelId][cmpName].length; // 是否存在多个相同的组件
        const detailCmpStyle = componentStyle[cmpName]; // 对应组件的高宽
        const totalWidth = length * detailCmpStyle.w;
        if (totalWidth) {
          const rows = parseInt(totalWidth / PANELCOLWIDTH, 10); // 是否需要换行
          const cols = totalWidth % PANELCOLWIDTH; // 下一个组件的开始x
          let width = 0;
          let height = 0;
          let curX = 0; // 当前组件开始的x值
          let curY = 0; // 当前组件开始的y值
          // 规则：因为vue-grid-layout都是正方形，所以即使该组件最下方没有填满，依然换行
          // 如果类似只有一个仪表盘和单输入组件，nextx可以更新
          // 如果超过一行
          if (rows > 0) {
            curX = 0;
            curY = preY;
            width = PANELCOLWIDTH;
            height = (detailCmpStyle.h * rows) + (detailCmpStyle.h * (cols ? 1 : 0));
            preX = 0;
            preY += height;
            // 如果没超过一行，但是和之前的组件宽度加起来超过一行，暂时只有dashboard和singleBind会出现
          } else if ((cols + preX) / PANELCOLWIDTH > 1) {
            curX = 0;
            curY = preY;
            width = cols;
            height = detailCmpStyle.h;
            preX = width;
            preY += height;
          } else {
            curX = preX;
            curY = preY;
            width = cols;
            height = detailCmpStyle.h;
            preX += width; // preY不变
          }
          cmpPositionStyle.push({
            cmpName,
            position: {
              x: curX, y: curY, w: width, h: height,
            },
          });
        }
      }
    }
    state.curComponentX = preX;
    state.curComponentY = preY;
  },
  // 点击删除组件
  deleteComponent(state, payload) {
    const { componentIndex } = payload;
    state.panelDataCcg.splice(componentIndex, 1);
    state.panelChanged = true;
  },
  // 添加信号或观测量到示波图组件
  addSignalToOscr(state, payload) {
    const { dragNode, componentIndex, type } = payload;
    const { panelDataCcg } = state;
    const { dataSources } = panelDataCcg[componentIndex];
    // 如果当前组件中包含了信号或者观测量则不添加
    if (dataSources.length < 1 || dataSources.filter(item => item.key === dragNode.id).length < 1) {
      console.log(state.panelDataCcg[componentIndex].dataSources);
      state.panelDataCcg[componentIndex].dataSources.push({
        comment: '',
        key: dragNode.id,
        text: dragNode.text,
        type,
      });
      state.panelDataCcg[componentIndex].enables.push(true);
      this.dispatch('Engineering/saveAllCpt').then(() => {
        this.dispatch('Engineering/getInitPanelData');
      });
    }
  },
  // 拖拽仪表盘组件
  addDashboard(state, payload) {
    const { dragNode, componentIndex, type } = payload;
    const { panelList, displayDetailTabIndex } = state;
    const curCmpData = getCurCmpData(state);
    const curCmpDataSource = getCurCmpDataSourceData(state, 2, componentIndex);
    curCmpDataSource.dataSources.push({
      key: dragNode.id,
      text: dragNode.text,
      type,
    });
    curCmpDataSource.signalSourceArr.push({
      key: dragNode.id,
      text: dragNode.text,
    });
    this.dispatch('Engineering/savePanelData', {
      panelId: panelList[displayDetailTabIndex].id,
      initPanelData: curCmpData.dataSource,
    });
  },
  // 拖拽标定量组件
  addSignaToSingleCmp(state, payload) {
    const { dragNode, componentIndex } = payload;
    const {
      text, id, dtype: type,
    } = dragNode;
    state.panelDataCcg[componentIndex].dataSources.unshift({
      text, key: id, type,
    });
    this.dispatch('Engineering/saveAllCpt');
  },
  /**
   * 添加信号源到仪表盘中
   * @param state
   * @param paload
   */
  addSingnalToDashboaord(state, { dragNode, componentIndex }) {
    const {
      text, id: key, dtype: type, unit = '', value = 0,
    } = dragNode;
    // 将原有的数据清空
    state.panelDataCcg[componentIndex].dataSources.length = 0;
    state.panelDataCcg[componentIndex].dataSources.push({
      text, key, type, unit, value,
    });
    console.log(state.panelDataCcg);
    this.dispatch('Engineering/saveAllCpt');
  },
  /**
   * 向单数据显示插件中添加数据源
   * @param state
   * @param payload
   */
  addSignalToSingleOutput(state, { dragNode, componentIndex }) {
    if (dragNode.children.length > 0) {
      dragNode.children.map((item) => {
        const {
          text, id: key, dtype: type, unit = '', value = 0,
        } = item;
        state.panelDataCcg[componentIndex].dataSources.push({
          text, key, type, unit, value,
        });
      });
    } else {
      const {
        text, id: key, dtype: type, unit = '', value = 0,
      } = dragNode;
      state.panelDataCcg[componentIndex].dataSources.push({
        text, key, type, unit, value,
      });
    }
    this.dispatch('Engineering/saveAllCpt').then(() => {
      // this.dispatch('Engineering/getInitPanelData');
    });
  },

  /**
   * 向Indicator组件中添加数据源
   * @param state
   * @param payload
   */
  addSignalToIndicator(state, { dragNode, componentIndex }) {
    if (dragNode.children.length > 0) {
      dragNode.children.map((item) => {
        const {
          text, id: key, dtype: type, unit = '', value = 0,
        } = item;
        state.panelDataCcg[componentIndex].dataSources = [];
        state.panelDataCcg[componentIndex].dataSources.push({
          text, key, type, unit, value,
        });
      });
    } else {
      const {
        text, id: key, dtype: type, unit = '', value = 0,
      } = dragNode;
      state.panelDataCcg[componentIndex].dataSources = [];
      state.panelDataCcg[componentIndex].dataSources.push({
        text, key, type, unit, value,
      });
    }
    this.dispatch('Engineering/saveAllCpt');
  },

  /**
   * 向地图插件中添加数据源（主要是经度和纬度）
   * @param state
   * @param payload
   */
  addSignalToBaiduMap(state, { dragNode, componentIndex }) {
    const {
      text, id: key, dtype: type, unit = '', value = 0,
    } = dragNode;
    state.panelDataCcg[componentIndex].dataSources.push({
      text, key, type, unit, value,
    });
    this.dispatch('Engineering/saveAllCpt');
  },

  /**
   * 向UDS插件中添加模板信息
   * @param state
   * @param payload
   */
  addTemplateToUDS(state, { dragNode, componentIndex }) {
    const {
      text, deviceId, canConfigId,
    } = dragNode;
    // 为模板数据添加特殊的Key，包含两个Id信息
    const type = 'UDS_INFO';
    const key = `${text}_${deviceId}_${canConfigId}`;
    // 一个UDS组件仅允许绑定一个模板，清空此前模板信息
    state.panelDataCcg[componentIndex].dataSources = [];
    state.panelDataCcg[componentIndex].dataSources.push({
      key, type,
    });
    this.dispatch('Engineering/saveAllCpt');
  },

  // 根据can的switch变化，来变化对应组件的switch
  switchDetailSingleBind(state, payload) {
    const { targetPage, canId } = payload;
    const singleBindIndex = state.canBindSingleBind[canId];
    if (singleBindIndex !== undefined && singleBindIndex.length) {
      const singleBindIndexObj = singleBindIndex.map(item => ({
        [item]: (targetPage === 1) ? 'job' : 'refer',
      }));
      let temp = {};
      singleBindIndexObj.forEach((item) => {
        temp = {
          ...state.singleBindStatus,
          ...item,
        };
      });
      state.singleBindStatus = JSON.parse(JSON.stringify(temp));
    }
  },
  // 拖拽到发送组件下
  addSubmitCmp(state, payload) {
    const {
      id, dtype, text, componentIndex,
    } = payload;
    console.log(dtype);
    state.panelDataCcg[componentIndex].dataSources = [];
    state.panelDataCcg[componentIndex].dataSources.push({
      key: id, text, type: dtype,
    });
    this.dispatch('Engineering/saveAllCpt');
    //   .then(() => {
    //   this.dispatch('Engineering/getInitPanelData');
    // });
    // 待删除
  },
  // 添加自定义帧
  addCustomFrame(state, payload) {
    const { customFrames, componentIndex } = payload;
    console.log(customFrames);
    state.panelDataCcg[componentIndex].dataSources = customFrames;
    this.dispatch('Engineering/saveAllCpt');
  },
  // 修改组件的右侧数据
  setComponentRightType(state, payload) {
    const { fieldName, value } = payload;
    const { rightAsideComponentName, activedClickCmp } = state;
    let curDataSource;
    switch (rightAsideComponentName) {
      case 'submitCmp':
        curDataSource = getCurCmpDataSourceData(state, 4, activedClickCmp[rightAsideComponentName]);
        curDataSource[fieldName] = value;
        break;
      default:
        break;
    }
  },
  /* 改变发送组件中的值 */
  setSendMsg(state, newData) {
    state.sendMsg.push(newData);
  },
  /* 根据数据返回，对chart图等其他数据进行处理
       * 其中对标定量组件需要仔细说明下
       * 标定量组件只能接受一个canid，后台返回的信号列表，需要和树状结构来匹配
       * 得到相应的canid和组件（组件中有最大最小值，需要控制input的输入）
       */
  transformDataToPanelObj(state, payload) {
    const {
      chartData, dashboardData, inputData, submitData, dataSource, panelId,
    } = payload;
    const signalCmp = transformToSignalCmp(chartData);
    const dashboard = transformToDashboard(dashboardData);
    const singleBind = transformToSingleBind(inputData, this, state);
    singleBind.forEach((item, index) => {
      if (item.bindCanId) {
        if (state.canBindSingleBind[item.bindCanId]
          && !state.canBindSingleBind[item.bindCanId].includes(index)) {
          state.canBindSingleBind[item.bindCanId].push(index);
        } else {
          state.canBindSingleBind[item.bindCanId] = [index];
        }
      }
    });
    const submitCmp = transformToSubmit(submitData);
    const detailPanelIdData = {
      [panelId]: {
        signalCmp,
        dataSource,
        singleBind,
        dashboard,
        submitCmp,
      },
    };
    this.commit('Engineering/setDetailPanelIdData', {
      detailPanelIdData,
    });
  },
  addCmpToPanelObj(state, payload) {
    // eslint-disable-next-line
    let curActivePanelData = getCurCmpData(state);
    let signalCmp;
    let dashboard;
    let singleBind;
    let submitCmp;
    switch (payload.ctype) {
      case '1':
        signalCmp = transformToSignalCmp(payload.addComponentData);
        if ('signalCmp' in curActivePanelData) {
          curActivePanelData.signalCmp = JSON.parse(JSON.stringify([
            ...curActivePanelData.signalCmp,
            ...signalCmp,
          ]));
        } else {
          curActivePanelData.signalCmp = signalCmp;
        }
        break;
      case '2':
        dashboard = transformToDashboard(payload.addComponentData);
        if ('dashboard' in curActivePanelData) {
          curActivePanelData.dashboard = JSON.parse(JSON.stringify([
            ...curActivePanelData.dashboard,
            ...dashboard,
          ]));
        } else {
          curActivePanelData.dashboard = dashboard;
        }
        break;
      case '3':
        singleBind = transformToSingleBind(payload.addComponentData, this);
        if ('singleBind' in curActivePanelData) {
          curActivePanelData.singleBind = JSON.parse(JSON.stringify([
            ...curActivePanelData.singleBind,
            ...singleBind,
          ]));
        } else {
          curActivePanelData.singleBind = singleBind;
        }
        break;
      case '4':
        submitCmp = transformToSubmit(payload.addComponentData);
        if ('submitCmp' in curActivePanelData) {
          curActivePanelData.submitCmp = JSON.parse(JSON.stringify([
            ...curActivePanelData.submitCmp,
            ...submitCmp,
          ]));
        } else {
          curActivePanelData.submitCmp = submitCmp;
        }
        break;
      default:
        break;
    }
    if ('dataSource' in curActivePanelData) {
      curActivePanelData.dataSource = JSON.parse(JSON.stringify([
        ...curActivePanelData.dataSource,
        ...payload.addComponentData,
      ]));
    } else {
      curActivePanelData.dataSource = payload.addComponentData;
    }
  },
  // 新建组件后将返回的数据添加到组件对象中
  addComponentForDetailPanel(state, payload) {
    const {
      cid = '', ctype = '', dataSources = [], enables = [], name = '', pos = {}, size = {}, zindex = 0,
      trueValue = 1, falseValue = 0,
    } = payload.res;
    const position = payload.pos;
    const chartData = dataSources.map(dataSourceitem => ({
      key: dataSourceitem.key,
      values: [],
    }));
    let sizeW = size.x / 6;
    let sizeH = size.y / 3;
    if (ctype === COMPONENT_TYPE.SWITCHER) {
      // sizeW = size.x / 6;
      // sizeH = size.y / 2;
      sizeW = 18;
      sizeH = 60;
    }
    if (ctype === COMPONENT_TYPE.MAP) {
      sizeW = 24;
      sizeH = 83;
    }
    if (ctype === COMPONENT_TYPE.UDS) {
      sizeW = 35;
      sizeH = 200;
    }
    if (ctype === COMPONENT_TYPE.DASHBOARD) {
      sizeW = 15;
      sizeH = 60;
    }
    if (ctype === COMPONENT_TYPE.Oscillogram) {
      sizeW = 15;
      sizeH = 65;
    }
    if (ctype === COMPONENT_TYPE.SEND || ctype === COMPONENT_TYPE.OUTPUT || ctype === COMPONENT_TYPE.INPUT) {
      // sizeW = size.x / 20;
      // sizeH = size.y / 5;
      sizeW = 16;
      sizeH = 60;
    }
    if (ctype === COMPONENT_TYPE.CUSTOMFRAMES || ctype === COMPONENT_TYPE.CONDITION) {
      // sizeW = size.x / 6;
      // sizeH = size.y / 5;
      sizeW = 30;
      sizeH = 55;
    }
    if (ctype === COMPONENT_TYPE.NUMERICCONTROL) {
      sizeW = 4;
      sizeH = 11;
    }
    if (ctype === COMPONENT_TYPE.NUMERICINDICATOR) {
      sizeW = 3;
      sizeH = 9;
    }
    if (ctype === COMPONENT_TYPE.SLIDER) {
      sizeW = 7;
      sizeH = 22;
    }
    if (ctype === COMPONENT_TYPE.TRIGGER) {
      sizeW = 2;
      sizeH = 12;
    }
    state.panelDataCcg.push({
      cid,
      ctype,
      dataSources,
      enables,
      name,
      i: 0,
      x: position[0],
      y: position[1],
      w: sizeW,
      h: sizeH,
      styleSetting: [],
      zindex,
      chartData,
      trueValue,
      falseValue,
    });
  },
  // 点击面板，把对应面板数据加入到initPanelDataOjb当中
  setDetailPanelIdData(state, payload) {
    state.initPanelDataObj = JSON.parse(JSON.stringify({
      ...state.initPanelDataObj,
      ...payload.detailPanelIdData,
    }));
  },
  setSingleBindCmp(state, payload) {
    const { singleBindValue } = payload;
    state.singleBindValue = singleBindValue;
  },
  // 点击信号源，选择展示选中☑️的
  setSignalSourceDetailIndex(state, payload) {
    const {
      detailIndex, detailStatus, componentIndex, signalKey,
    } = payload;
    const curCmpSignalData = getCurCmpSignalData(state, payload);
    const curCmpDataSource = getCurCmpDataSourceData(state, 1, componentIndex);
    curCmpDataSource.enables[detailIndex] = detailStatus;
    // 如果是state的属性指向的是一个对象，则需要重新替换为新对象，getter才会有变化
    const newCheckedArr = curCmpSignalData.signalSourceCheckedArr;
    newCheckedArr[signalKey] = detailStatus;
    curCmpSignalData.signalSourceCheckedArr = JSON.parse(JSON.stringify(newCheckedArr));
  },
  // 点击信号源，删除不需要的信号源
  deleteSignalSourceDetailIndex(state, payload) {
    const { detailIndex, componentIndex, signalKey } = payload;
    state.panelDataCcg[componentIndex].dataSources.splice(detailIndex, 1);
    this.dispatch('Engineering/saveAllCpt');
  },

  /**
   * websockets收到数据进行vuex设置
   * @param statenpmnpm
   * @param message
   */
  setPanelData(state, { message }) {
    const { panelDataCcg } = state;
    console.time('新ws消息处理');
    message.forEach((item) => {
      // 组件的序号
      const index = panelDataCcg.findIndex(item2 => item2.cid === item.componentId);
      if (index === -1) {
        console.error('未找到组件，id=>', item.componentId);
      } else {
        const messageReg = /signal:[\d]{18}[\\.][\d]*[\\.]/;
        const { data = [] } = item;
        const componentData = panelDataCcg[index];
        const dataSourceChecked = {};
        // 遍历当前的data，将每个元素的values合并到每个组件的数据源中
        data.forEach((dataItem) => {
          if (messageReg.test(dataItem.key)) {
            const sign = messageReg.exec(dataItem.key)[0];
            componentData.dataSources.map((item) => {
              if (item.key.indexOf(sign) > -1 && item.key.indexOf('#TIME') > -1) {
                const timeValue = cloneDeep(dataItem.values);
                timeValue[0].value = timeValue[0].time;
                componentData.chartData.push({
                  key: item.key,
                  values: timeValue,
                });
              }
            });
          }
          const dataSourceIndex = componentData.chartData.findIndex(chartDataIndex => chartDataIndex.key === dataItem.key);
          if (dataSourceIndex === -1) { // 如果当前组件中没有推送的dataSource的key，就新建一个
            componentData.chartData.push({
              key: dataItem.key,
              values: dataItem.values,
              newDataIndex: 0, // 最新数据所在的索引，方便图形绘制时只添加新数据
            });
          } else { // 如果存在就把dataItem中的value合并到数据源对应的values中
            const datasourceChartData = componentData.chartData[dataSourceIndex];
            const oldValues = datasourceChartData.values;
            // 检查是否有这个key，有就是checked过了
            // if (!Object.prototype.hasOwnProperty.call(dataSourceChecked, datasourceChartData.key) {
            //
            // }
            if (!dataSourceChecked[datasourceChartData.key]) {
              dataSourceChecked[datasourceChartData.key] = datasourceChartData;
              datasourceChartData.newDataIndex = oldValues.length; // 设置新数据的索引
            }
            // console.debug(`oldValue=${oldValues.length}`);
            oldValues.push(...dataItem.values);
            // console.debug(`newValue=${oldValues.length}`);
          }
        });
        // 最后一次性移除超过最大限制的点
        const keys = Object.keys(dataSourceChecked);
        keys.forEach((key) => {
          const datasourceChartData = dataSourceChecked[key];
          const { length } = datasourceChartData.values;
          let maxNum = 1; // 默认是最大1个
          if (componentData.ctype === COMPONENT_TYPE.Oscillogram) {
            maxNum = Constants.OSCILLOGRAM_CHART_MAX_NODE_NUM;
          }
          if (length > maxNum && componentData.ctype !== COMPONENT_TYPE.Oscillogram) {
            const delta = length - maxNum;
            console.debug(`超出图形最大可保存的节点数量${maxNum}个，当前为${length}个, 移除${delta}个`);
            datasourceChartData.values.splice(0, delta);
            datasourceChartData.newDataIndex -= delta; // 减少索引
          }
        });
      }
    });
    console.timeEnd('新ws消息处理');
    // console.debug('新msg处理完毕');
  },
  // 点击组件，展示现有的组件的名称，名称和componentStyleInfoArray的字段一致
  clickComponent(state, payload) {
    const { componentName, cmpIndex, cmpType } = payload;
    state.rightAsideComponentName = componentName;
    state.activedClickCmp[cmpType] = cmpIndex;
  },
  setPanelStartStatus(state, payload) {
    const { displayDetailTabIndex, startStatus } = payload;
    // state.panelList[displayDetailTabIndex].hasStart = startStatus;
  },
  // 设置面板
  setPanelList(state, payload) {
    state.panelList = payload;
  },
  // 设置面板id列表
  setPanelIdList(state, payload) {
    const panelIdList = payload;
    state.panelIdList = JSON.parse(panelIdList);
  },
  // 面板复制，直接添加在panelList之后
  addPanel(state, payload) {
    const { panel } = payload;
    state.panelList.push(panel);
  },
  // 删除面板
  deleteDetailPanelTab(state, payload) {
    state.panelList.splice(payload.panelIndex, 1);
  },
  setReportTabName(state, payload) {
    const { index, name } = payload;
    state.panelList[index].name = name;
  },
  // 设置被修改组件的字段
  setComponentStyle(state, payload) {
    const { componentName, componentField, value } = payload;
    state.componentStyleInfoArray[componentName][componentField] = value;
  },

  // 增加UDS响应
  addUdsResponse(state, payload) {
    this.commit('Engineering/addUdsTracker');
    const { udsResult, panelId } = payload;
    if (state.udsResponse.get(panelId) !== undefined) {
      const resultArr = state.udsResponse.get(panelId);
      resultArr.push(udsResult);
      state.udsResponse.set(panelId, resultArr);
    } else {
      const resultArr = [];
      resultArr.push(udsResult);
      state.udsResponse.set(panelId, resultArr);
    }
  },

  // 增加追踪，诱导更新
  addUdsTracker(state) {
    state.udsTracker += 1;
  },

  // 删除UDS响应中的某一次响应结果
  deleteUdsResponse(state, payload) {
    const { request, time, panelId } = payload;
    const udsResponse = state.udsResponse.get(panelId);
    udsResponse.forEach((item, index) => {
      if (item.request === request && item.time === time) {
        udsResponse.splice(index, 1);
      }
    });
    state.udsResponse.set(panelId, udsResponse);
    this.commit('Engineering/addUdsTracker');
  },
  setAllTreeNodeList(state, payload) {
    state.allTreeNodeList = payload;
    window.sessionStorage.setItem('allTreeNodeList', payload);
  },
  setAnchorKeyWord(state, payload) {
    let keyword = payload;
    if (payload.indexOf(':measurement:') > -1) {
      keyword = payload.split(':measurement:')[payload.split(':measurement:').length - 1];
    }
    state.anchorKeyWord = keyword;
  },
  // 配置发送组件刷新key
  setCmpSyncKey(state) {
    state.cmpSyncKey += 1;
  },
  // 配置Control组件刷新key
  setControlSyncKey(state, payload) {
    const keyList = payload;
    state.controlSyncKey += 1;
    state.controlSyncKeyList = keyList;
  },
  // 自定义组件初始样式配置
  setCptStyle(state, payload) {
    const componentStyles = payload;
    for (let i = 0; i < componentStyles.length; i += 1) {
      const id = componentStyles[i].componentId;
      for (let j = 0; j < state.panelDataCcg.length; j += 1) {
        if (id == state.panelDataCcg[j].cid) {
          const setting = {
            fontSize: componentStyles[i].wordSize,
            fontColor: componentStyles[i].wordColor,
            size: componentStyles[i].componentSize,
            step: componentStyles[i].step,
          };
          // state.panelDataCcg[j].setting = setting;
          state.panelDataCcg[j].styleSetting.push(setting);
          break;
        }
      }
    }
  },
  // 自定义组件初始样式配置
  setCptSignalName(state, payload) {
    const nameList = payload;
    for (let i = 0; i < nameList.length; i += 1) {
      const id = nameList[i].componentId;
      for (let j = 0; j < state.panelDataCcg.length; j += 1) {
        if (id == state.panelDataCcg[j].cid) {
          // state.panelDataCcg[j].signalName = nameList[i].name;
          // state.panelDataCcg[j].styleConfig.push({ name: nameList[i].name });
          state.panelDataCcg[j].dataSources[0].text = nameList[i].name;
          break;
        }
      }
    }
  },
  // 选中自定义组件
  selectCpt(state, payload) {
    const id = payload;
    if (state.selectedCpts.indexOf(id) > -1) {
      state.selectedCpts.splice(state.selectedCpts.indexOf(id), 1);
    } else {
      state.selectedCpts.push(id);
    }
  },
  // 清空选中自定义组件
  clearCpt(state) {
    state.selectedCpts = [];
  },
  setBindIniKey(state) {
    state.bindIniKey += 1;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/engineering/mutations.js